const apiURL = {
  baseURL: '/h5-api', // baseURL
  albums: '/album/', // 相册
  photoList: '/photo', // 相册照片列表
  photo: '/photo', // 照片列表
  photoGroup: '/photo-groups/?photo_group=1', // 照片组列表
  collect: '/user-fav', // 收藏列表
  addFavorite: '/user-fav/', // 收藏
  removeFavorite: '/user-fav/', // 取消收藏
  addLike: '/user-vote/', // 点赞
  removeLike: '/user-vote/', // 取消点赞
  deletePhoto: '/photo/', // 删除照片
  canDeletePhoto: '/photo-can-hidden', // 获取是否可以删除照片
  wxConfig: '/wechat-js-token',
  qrcode: '/generate-qrcode', // 生产二维码
  download: '/generate-download-url', // 更新下载次数
  viewPhotoCount: '/track/view-photo', // 更新下载次数
}

export default apiURL;